import TomSelect from 'tom-select';
import {Input} from '@main/components/form/form-field/input';
import {ConditionalSelect} from '@main/components/form/form-field/conditional-select';
/**
 * Компонент селекта.
 */
export class Select extends Input {
  /**
   * Создает компонент выбора файла.
   *
   * @param {object} props - Параметры компонента.
   * @param {HTMLElement} props.container - Родительский элемент.
   * @param {HTMLInputElement} props.input - Элемент ввода.
   */
  constructor({container, input}) {
    super({container, input});

    this.tomSelect = new TomSelect(this.input, {
      hideSelected: false,
      controlClass: 'form-field__input ts-control',
      dropdownClass: 'ts-dropdown',
      controlInput: null,
      maxOptions: 100,
      render: {
        no_results: function () {
          return '<div class="option">Ничего не найдено</div>';
        },
      },
      onType: (str) => {
        if (str) {
          this.el.classList.add('filled');
        } else {
          this.updateIsFilledStatus();
        }
      },
    });
    this.input.classList.remove('form-field__select');

    this.input.addEventListener('setSelectValue', (e) => {
      this.tomSelect.setValue(e.detail);
      this.el.classList.add('filled');
    });

    this.input.addEventListener('setOptions', (e) => {
      this.setOptions(e.detail);
    });

    this.input.addEventListener('loading', (e) => {
      this.el.classList.add('loading');
    });

    this.input.addEventListener('endLoading', (e) => {
      this.el.classList.remove('loading');
    });

    this.initConditionalLogic();
  }

  initConditionalLogic() {
    const container = this.input.closest('.js-conditional-select');
    if (container) {
      setTimeout(() => {
        this.conditionalSelect = new ConditionalSelect(container);
      }, 100);
    }
  }

  /**
   * Очищает выбранные значения
   */
  clear() {
    this.tomSelect.clear();
    this.tomSelect.clearOptions();
    this.el.classList.remove('filled');
  }

  /**
   * Установить список выбора извне
   * @private
   */
  setOptions(options) {
    this.removeOptions();
    this.printOptions(options);
    this.tomSelect.sync();
    if (this.tomSelect.getValue().length) {
      this.el.classList.add('filled');
    } else {
      this.el.classList.remove('filled');
    }
  }

  /**
   * Сбросить список вариантов
   * @private
   */
  removeOptions() {
    [...this.input.querySelectorAll('option')].forEach((option) => {
      if (!option.classList.contains('js-always')) {
        option.remove();
      }
    });
  }

  /**
   * Построить список
   * @private
   */
  printOptions(options) {
    if (!options) {
      return;
    }
    [...options].forEach((option) => {
      this.input.insertAdjacentHTML('beforeend', `<option value="${option.value}">${option.title}</option>`);
    });
  }
}
